import I18n from "i18n-js";
import React from "react";
import DisabledLineItem from "./DisabledLineItem";

class RoomsDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var self = this;
    if (self.props.row.rooms && self.props.row.rooms.length > 0) {
      var rooms = [];
      for (let step = 0; step < self.props.row.rooms.length; step++) {
        if (step < 4) {
          if (self.props.row.room_type_datatable) {
            rooms.push(
              <li key={self.props.row.rooms[step].id}>
                {self.props.row.rooms[step].identifier}
              </li>
            );
          }
          if (
            !self.props.row.rooms[step].identifier &&
            self.props.row.rooms[step].room_type_name
          ) {
            rooms.push(
              <li key={self.props.row.rooms[step].id}>
                <span style={{ fontStyle: "italic" }}>
                  {I18n.t("unassigned")}
                </span>
                {" (" + self.props.row.rooms[step].room_type_name + ")"}
              </li>
            );
          } else if (
            self.props.row.rooms[step].room_type_name &&
            !self.props.row.room_type_datatable
          ) {
            rooms.push(
              <li key={self.props.row.rooms[step].id}>
                {self.props.row.rooms[step].identifier +
                  " (" +
                  self.props.row.rooms[step].room_type_name +
                  ")"}
              </li>
            );
          } else if (!self.props.row.room_type_datatable) {
            rooms.push(
              <li key={self.props.row.rooms[step].id}>
                {self.props.row.rooms[step].identifier} (
                <em>{I18n.t("none")}</em>)
              </li>
            );
          } 
        } else if (step === 4) {
          rooms.push(
            <li key="additional-rooms">
              <i>... {` ${I18n.t("more")}`}</i>
            </li>
          );
        }
      }
      return <ul className="RoomsDataType">{rooms}</ul>;
    } else if (
      self.props.row.room_groups &&
      self.props.row.room_groups.length > 0
    ) {
      var room_groups = [];
      for (let step = 0; step < self.props.row.room_groups.length; step++) {
        if (step < 4) {
          if (self.props.row.room_type_datatable) {
            room_groups.push(
              <li key={self.props.row.room_groups[step].id}>
                {self.props.row.room_groups[step].identifier}
              </li>
            );
          }

          if (
            !self.props.row.room_groups[step].identifier &&
            self.props.row.room_groups[step].room_type_name
          ) {
            room_groups.push(
              <li key={self.props.row.room_groups[step].id}>
                {self.props.row.room_groups[step].room_type_name}
              </li>
            );
          } else if (
            self.props.row.room_groups[step].room_type_name &&
            !self.props.row.room_type_datatable
          ) {
            if (
              self.props.row.room_groups[step].room_type_status == "enabled"
            ) {
              room_groups.push(
                <li key={self.props.row.room_groups[step].id}>
                  {self.props.row.room_groups[step].identifier +
                    " (" +
                    self.props.row.room_groups[step].room_type_name +
                    ")"}
                </li>
              );
            } else {
              room_groups.push(
                <DisabledLineItem
                  {...self.props.row.room_groups[step]}
                  disabledRoomGroupRoomType={true}
                />
              );
            }
          } else if (!self.props.row.room_type_datatable) {
            room_groups.push(
              <li key={self.props.row.room_groups[step].id}>
                {self.props.row.room_groups[step].identifier} (
                <em>{I18n.t("none")}</em>)
              </li>
            );
          }
        } else if (step === 4) {
          rooms.push(
            <li key="additional-rooms">
              <i>... {` ${I18n.t("more")}`}</i>
            </li>
          );
        }
      }
      return <ul className="RoomsDataType">{room_groups}</ul>;
    } else {
      return <i>{I18n.t("none")}</i>;
    }
  }
}

export default RoomsDataType;
